import React, { useEffect } from 'react'
import { List, ListItem, Popover, Theme, Tooltip, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { usePopover } from 'app/menu/components/TopBar/use-popover'
import { TopBarMenuItem } from './TopBarMenuItem'
import { useTranslation } from 'react-i18next'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import TimeRegistration from 'app/timeRegistration/TimeRegistration'

import { IRootReducerState } from 'state/rootReducer'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useGlobalSettings } from '../UserSettings/use-user-settings'
import { Locales } from '@carsys/enums/locales'
import { useFeature } from '@cbgms/base/feature-flags'

const useStyles = makeStyles({
  timeR: {
    minWidth: 200,
    width: '100%',
    '&:hover': {
      backgroundColor: '#ffffff'
    }
  },
  textOverflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  inline: {
    display: 'inline'
  }
})

export const TimeRegistrationMenu: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const hasAllOrdersinTimeRegistration = useFeature('orders-in-time-registration')
  const isTopbarUXChangeForTimerEnabled = useFeature('topbar-ux-change-for-timer')
  const isSmallerThanLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))

  const [timeREl, timeROpen, handleTimeRClick, handleTimeRClose] = usePopover()

  const currentActions = useSelector((state: IRootReducerState) => state.timeRegistration)
  const { globalSettings } = useGlobalSettings()

  const { pathname } = useLocation()
  useEffect(() => {
    handleTimeRClose()
  }, [pathname])

  return (
    <>
      {isTopbarUXChangeForTimerEnabled && isSmallerThanLG ? (
        <TopBarMenuItem isMenu badge={0} onClick={handleTimeRClick}>
          <Tooltip title={t('TimeRegistration.TimeRegistration')} placement='bottom'>
            <AccessTimeIcon />
          </Tooltip>
        </TopBarMenuItem>
      ) : (
        <TopBarMenuItem isMenu badge={0} onClick={handleTimeRClick} startIcon={<AccessTimeIcon />}>
          {t('TimeRegistration.TimeRegistration')}
        </TopBarMenuItem>
      )}
      <Popover
        open={timeROpen}
        anchorEl={timeREl}
        onClose={handleTimeRClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{
          style: {
            width: currentActions
              ? !currentActions.Day
                ? 200
                : globalSettings?.data?.Locale === Locales.en_GB ||
                  globalSettings?.data?.Locale === Locales.nl_NL ||
                  globalSettings?.data?.Locale === Locales.nl_BE
                ? hasAllOrdersinTimeRegistration
                  ? 1000
                  : 850
                : hasAllOrdersinTimeRegistration
                ? 1050
                : 900
              : 200,
            minWidth: 200
          }
        }}
      >
        <List className={classes.timeR}>
          <ListItem>
            <TimeRegistration />
          </ListItem>
        </List>
      </Popover>
    </>
  )
}
